import { IEvents } from "@walletconnect/jsonrpc-types";
export class IHeartBeat extends IEvents {
    constructor(opts) {
        super();
    }
}
//# sourceMappingURL=heartbeat.js.map